<template>
  <div class="field-filler">
    <div v-for="value in values" @click="fill(value)" :key="value.name" class="field-filler--value">
      {{$t(value.code)}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    values: {
      type: Array,
      required: true
    },
    elements: {
      required: true
    },
    elementName: {}
  },
  methods: {
    fill(value){
      this.insertSomething(value.content)
    },
    insertSomething(insert) {
      let tArea = this.elements[this.elementName].$el.querySelector('textarea, input')

      // get cursor's position:
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let cursorPos = startPos
      let tmpStr = tArea.value

      // insert:
      let newContent = tmpStr.substring(0, startPos)
        + insert
        + tmpStr.substring(endPos, tmpStr.length)

      this.$emit('input', newContent)

      // move cursor:
      setTimeout(() => {
        cursorPos += insert.length
        tArea.selectionStart = cursorPos
        tArea.selectionEnd = cursorPos
        tArea.focus()
      }, 10);
    }
  }
}
</script>
<style lang="sass">
.field-filler
  margin-bottom: 10px
  margin-top: -10px
  .field-filler--value
    display: inline-block
    margin-right: 5px
    padding: 4px 10px
    background: $paper-light
    font-size: 14px
    font-weight: $font-medium
    color: $ink-light
    border-radius: 3px
    cursor: pointer
    margin-bottom: 1em
    transition: all .15s ease-out
    &:hover
      color: $ink
      background: $paper
    &:active
      color: $sensual
      background: $sensual-lighter

</style>



// WEBPACK FOOTER //
// FieldFiller.vue?bfbf1662